import { z } from 'zod'

import { fileNameSchema } from '../../entities/file'

export const ALLOWED_CONTENT_TYPES = ['image/jpeg'] as const
export const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024

export const fileContentTypeSchema = z.enum(ALLOWED_CONTENT_TYPES, {
  message: 'File must be a JPEG image',
})

export const postFileUploadUrlBodySchema = z.object({
  fileName: fileNameSchema,
  contentType: fileContentTypeSchema,
  sizeBytes: z.number().int().positive().max(MAX_FILE_SIZE_BYTES),
})

export type PostFileUploadUrlBody = z.infer<typeof postFileUploadUrlBodySchema>

export const postFileUploadUrlResponseSchema = z.object({
  uploadUrl: z.string(),
  s3Key: z.string(),
})
export type PostFileUploadUrlResponse = z.output<typeof postFileUploadUrlResponseSchema>
